import { detect } from 'detect-browser'
const browser = detect()
/*
 * Get image from applied CDN
 *
 * @id param String
 * @type param String
 * @extra_parameters param Object  { 'height:':"", 'width':""}
 */

export const getVideoUrl = (vidUrl) => {
  const videoUrl = vidUrl ? vidUrl : ""
  return videoUrl
};

export const getCdnImage = (
  src,
  dimension = { w: '' },
) => {
  const width = dimension?.w
  const quality = dimension?.q
  const format = dimension?.fm
  let image_format = format ? format : 'webp'
  if (typeof src !== 'string' || !src) return ''
  let end_point_url = !src.includes('http') ? `https:${src}` : src
  const { isFormatAvailable, isQueryAvailable, isWidthAvailbale, isQualityAvailable } = URLparser(end_point_url)
  if (isFormatAvailable && isWidthAvailbale) return end_point_url
  if (!src.includes('svg')) {
      const isIos = browser && (browser.name === 'safari' || browser.name === 'ios')
      
      if (!isFormatAvailable) {
          if (isIos) {
              end_point_url = `${end_point_url}${isQueryAvailable ? '&' : '?'}fm=${image_format}`
          } else {
              end_point_url = `${end_point_url}${isQueryAvailable ? '&' : '?'}fm=${image_format}`
          }
      }

      if (width && width !== 'auto' && !isWidthAvailbale) {
          end_point_url = `${end_point_url}&w=${width}`
      }
      if (!isQualityAvailable) {
          if(end_point_url.includes('w=') || end_point_url.includes('fm=')) {
              end_point_url = `${end_point_url}`
          } else {
              end_point_url = `${end_point_url}`
          }
      }
  }

  return end_point_url
}
const URLparser = (url = '') => {
  try {
    const loc = new URL(url)
    const serachParams = loc.searchParams
    return {
      isQueryAvailable: !!loc.search?.trim(),
      isWidthAvailbale: serachParams.has('w'),
      isFormatAvailable: serachParams.has('fm'),
      isQualityAvailable: serachParams.has('q'),
    }
  } catch (msg) {
    console.error(msg)
  }
}

export function getSrcSetW(imageUrl, width) {
  return getCdnImage(imageUrl, {
    w: `${width}`,
  });
}
export function getVideoSrcSetW(videoUrl, width) {
  return getVideoUrl(videoUrl).replace(/q_auto/g, `w_${width},q_auto`);
}

export const getOptimizedImage = (url, size) => {
  return `${url}?w=${size.w}&h=${size.h}`;
};
